import React from "react";
import {css} from "@emotion/react";

import {useModal} from "@pg-design/modal";

import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {useGetReelsListQuery} from "../../../reels/api/get_reels_list";
import {ReelDetails} from "../../../reels/components/details/ReelDetails";
import {ReelModal} from "../../../reels/components/modal/ReelModal";
import {useReelsSortByPlays} from "../../../reels/hooks/use_reels_sort_by_plays";
import {IReelListItem} from "../../../reels/types/IReelListItem";
import {useOfferLink} from "../../detail/hooks/use_offer_link";
import {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IPropertyDetailOffer | IOfferDetail;
    reelData: IReelListItem;
}

export const GalleryHolderReel = (props: IProps) => {
    const {offer, reelData} = props;

    const locationOrigin = typeof window !== "undefined" ? window.location.origin : "";
    const offerLink = useOfferLink(offer);
    const shareUrl = `${locationOrigin}${offerLink}`;
    const modal = useModal();
    const {data: reelListData} = useGetReelsListQuery({offerId: offer.id});
    const {reels} = useReelsSortByPlays({reels: reelListData?.results}, [reelListData?.results, modal.isModalRendered]);

    const handleOnClick = () => {
        modal.openModal();
    };

    return (
        <div css={reelWrapperStyle}>
            <ReelDetails
                showCover
                disableActionButton
                reelId={reelData.id}
                reelDetails={reelData}
                shareUrl={shareUrl}
                shareDropdownWidth="15rem"
                handleOnClick={handleOnClick}
            />
            <ReelModal modalInstance={modal} reels={reels} />
        </div>
    );
};

const reelWrapperStyle = css`
    position: absolute;
    inset: 0;
`;
import React from "react";
import {css} from "@emotion/react";

import {useModal} from "@pg-design/modal";

import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {useGetReelsListQuery} from "../../../reels/api/get_reels_list";
import {ReelDetails} from "../../../reels/components/details/ReelDetails";
import {ReelModal} from "../../../reels/components/modal/ReelModal";
import {useReelsSortByPlays} from "../../../reels/hooks/use_reels_sort_by_plays";
import {IReelListItem} from "../../../reels/types/IReelListItem";
import {useOfferLink} from "../../detail/hooks/use_offer_link";
import {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IPropertyDetailOffer | IOfferDetail;
    reelData: IReelListItem;
}

export const GalleryHolderReel = (props: IProps) => {
    const {offer, reelData} = props;

    const locationOrigin = typeof window !== "undefined" ? window.location.origin : "";
    const offerLink = useOfferLink(offer);
    const shareUrl = `${locationOrigin}${offerLink}`;
    const modal = useModal();
    const {data: reelListData} = useGetReelsListQuery({offerId: offer.id});
    const {reels} = useReelsSortByPlays({reels: reelListData?.results}, [reelListData?.results, modal.isModalRendered]);

    const handleOnClick = () => {
        modal.openModal();
    };

    return (
        <div css={reelWrapperStyle}>
            <ReelDetails
                showCover
                disableActionButton
                reelId={reelData.id}
                reelDetails={reelData}
                shareUrl={shareUrl}
                shareDropdownWidth="15rem"
                handleOnClick={handleOnClick}
            />
            <ReelModal modalInstance={modal} reels={reels} />
        </div>
    );
};

const reelWrapperStyle = css`
    position: absolute;
    inset: 0;
`;
